/**
 * @file: 快捷键白名单
 * @author: xiaolong.huang@dmall.com
 */

const whiteList: string[] = [
    'mousemove+space+mouseleft',
    'mousedown+space+mouseleft',
    'mouseup+space+mouseleft',
    'mousedown+mouseleft',
    'mouseup+mouseleft',
    'mousedown+mouseright',
    'mouseup+mouseright',
    'mousedown+shift+mouseleft',
    'keyup',
    'ctrl+mouseleft',
    'ctrl+a',
    'command+a',
    'keydown+space',
    'keyup+space',
    'dblclick',
    'ctrl+c',
    'command+mouseleft',
    'command+c',
    'ctrl+v',
    'command+v',
    'mousedown+mousecenter',
    'mouseup+mousecenter',
    'mousemove+mousecenter',
    'mousewheel+mousecenter',
    'press+backspace',
    'press+del',
    'ctrl+x',
    'command+x',
    'contextmenu',
    'mousedown',
    'press+number',
    'ctrl+i',
    'command+i',
    'press+w',
    'press+s',
    'press+a',
    'press+d',
    'press+e',
    'press+up+e',
    'appToBackground',
    'ctrl+s',
    'command+s',
    'command+r',
    'f5',
    'command+r',
    'ctrl+r',
    'ctrl+d',
    'command+d',
    'ctrl+k',
    'command+k',
    'ctrl+l',
    'command+l',
    'ctrl+g',
    'command+g',
    'ctrl+z',
    'command+z',
    'ctrl+shift+g',
    'ctrl+shift+l',
    'ctrl+shift+r',
    'ctrl+backspace',
    'ctrl+del',
    '/',
    'command+number',
    'ctrl+number',
    'press+esc',
    'mouseup',
    'mousedown+outsideofstage',
    'mousedown+c+mouseleft',
    'keyup+r'
];

export default whiteList;
